import React from "react";
import { Link } from "react-router-dom";
import "./styles.scss";
import routes from "../routes";

const SubHead = (props) => {
  const { location } = props;
  const routeData = routes.filter(
    (routeList) =>
      `/${location?.pathname.split("/")[1]}`.includes(routeList.path) &&
      routeList.SubMenu
  );
  const stepIndex = (function () {
    let index = 0;
     routeData[0]?.subMenus
      ?.filter((subHide) => !subHide.hideSideMenu)
      .forEach((item, i) => {
        if (location?.pathname === `${routeData[0]?.path}${item.path}`) {
          index = i;
        }
      });
      return index
  })();

  return (
    <div className="sub_head">
      {routeData[0]?.isStepperMenu ? (
        <>
          {routeData[0]?.subMenus
            ?.filter((subHide) => !subHide.hideSideMenu)
            .map((item, i) => (
              <div
                key={i}
                className={
                  stepIndex >= i
                    ? "active_step_sub_nav"
                    : "step_sub_nav"
                }
              >
                <Link to={routeData[0].path + item.path}>{item.label}</Link>
              </div>
            ))}
        </>
      ) : (
        <>
          {routeData[0]?.subMenus
            ?.filter((subHide) => !subHide.hideSideMenu)
            .map((item, i) => (
              <div
                key={i}
                className={
                  location?.pathname === `${routeData[0]?.path}${item.path}`
                    ? "activesub_nav"
                    : "sub_nav"
                }
              >
                <Link to={routeData[0].path + item.path}>{item.label}</Link>
              </div>
            ))}
        </>
      )}
    </div>
  );
};
export default SubHead;
